import Email from 'frontend/common/email.vue'
import { markRaw } from 'vue'

export const FIELDS = [
  'id',
  'provided_roles',
  {
    user: ['id', 'name', 'surname', 'email', 'was_signed_in'],
  },
]

export const SUBSCRIPTIONS = {
  items: 'OrganizationUsersChannel',
  users: 'UsersSimpleChannel',
}

export const DEFAULT_COLUMNS = ['userName', 'userSurname', 'userEmail', 'providedRoles', 'everSignedIn']

export const COLUMNS_CONFIG = {
  userName: {
    label: 'Name',
    header: {
      sort: 'user_name',
    },
    cell: {
      kind: 'simple',
      path: 'user.name',
    },
  },
  userSurname: {
    label: 'Surname',
    header: {
      sort: 'user_surname',
    },
    cell: {
      kind: 'simple',
      path: 'user.surname',
    },
  },
  userEmail: {
    label: 'Email',
    header: {
      sort: 'user_email',
    },
    cell: {
      kind: 'component',
      component: markRaw(Email),
      componentProps: organizationUser => ({
        email: organizationUser?.user?.email,
      }),
    },
  },
  providedRoles: {
    label: 'SSO Roles',
    header: {
      sort: 'provided_roles',
    },
    cell: {
      kind: 'function',
      fn: organizationUser => (organizationUser?.providedRoles || []).join(', ') || '-',
    },
  },
  everSignedIn: {
    label: 'Ever signed in',
    header: {
      sort: 'user_was_signed_in',
    },
    cell: {
      kind: 'component',
      component: 'true-false-label',
      componentProps: organizationUser => ({
        item:
          organizationUser?.user?.wasSignedIn
      }),
    },
  },
}


